import React from 'react'
import PropTypes from 'prop-types'
import {withFormsy} from 'formsy-react';
import Component from '../Component'


import SearchBoxNew from '../test/SearchBox';


class LocationField extends Component
{
	static propTypes = {
		location: PropTypes.shape({
			full: PropTypes.string,

			address_line_1: PropTypes.string,
			city: PropTypes.string,
			state: PropTypes.string,
			country: PropTypes.string,
			postal_code: PropTypes.string,

			latitude: PropTypes.number,
			longitude: PropTypes.number,
		}),

		onError: PropTypes.func,
	};

	constructor(props)
	{
		super(props);


		let location = props.getValue()

		this.state = {
			...this.state,
			showSelected: TB.isDefined(location)
				&& TB.isDefined(location.latitude)
		};
	}

	componentDidMount() {
		super.componentDidMount();

		try {
			document.querySelectorAll("#locationField input").forEach(element => {
				element.setAttribute('autocomplete', 'off')
			})
		}catch (e) {
			console.warn('ERROR: componentDidMount', e);
		}
	}

	onError(e)
	{
		// TB.log('LocationField @ onError', e);

		if (TB.isFunction(this.props.onError)) {
			this.props.onError(e);
		}
	}

	// onSelectPlace(place)
	// {
	// 	// TB.log().object('LocationField @ onSelectPlace', place);

	// 	let location = {
	// 		full: place.value,
	// 		address_line_1: place.type == 'address' ? place.name : place.address,
	// 		city: place.type == 'city' ? place.name : place.city,
	// 		state: place.administrative ? place.administrative : place.name,
	// 		country: place.country,
	// 		postal_code: place.postcode,
	// 		latitude: place.latlng.lat,
	// 		longitude: place.latlng.lng,
	// 	};

	// 	// TB.log().object('LocationField @ onChange', location);

	// 	this.props.setValue(location, true);
	// }

	clearLocation()
	{
		// TB.log('LocationField @ clearLocation');
		this.props.setValue(null);
	}

	renderPlaceSearch()
	{
		return TB.isDefined(this.props.getValue()?.latitude) ? (
			<div className="form-group" style={{ position: 'relative', borderBottom: '1px solid #D3D8DD' }}>
				<input readOnly style={{ width: '100%', border: 0, outline: 'none' }} type="text"
                       value={this.props.getValue() && this.props.getValue().full} />

				<button
					type="button"
					className="btn min-w-0"
					style={{position: 'absolute', right: 5, top: 5 }}
					onClick={this.clearLocation.bind(this)}
				>
					<svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M.566 1.698L0 1.13 1.132 0l.565.566L6 4.868 10.302.566 10.868 0 12 1.132l-.566.565L7.132 6l4.302 4.3.566.568L10.868 12l-.565-.566L6 7.132l-4.3 4.302L1.13 12 0 10.868l.566-.565L4.868 6 .566 1.698z"></path></svg>
				</button>
			</div>
		) : (
			<SearchBoxNew
                includeAddress={this.props.includeAddress}
				searchHint="Search for a city"
				token={'pk.eyJ1Ijoia2VpdGh3cmlwcGxlIiwiYSI6ImNsNTMxN2d4MTAxbTYzcW1mZmhnaW96eXkifQ.6LoANVf0-IcjzWSrZSPt3A'}
				// country="US"
				callback={({ location, event }) => {
					let parts = {};
					for (let part of location.context) {
						let key = part.id.split('.')[0];
						let value = part.text;
						if (key == 'country' && part.short_code) {
							parts.country_name = value;
							value = part.short_code.toUpperCase();
						}
						parts[key] = value;

					}
					if (!parts.country) {
						return this.onError("Invalid location selected");
					}
					let city = location.place_name.replace(', '+parts.country_name, '');
					if (parts.region) {
						city = city.replace(', '+parts.region, '');
					}
                    if (parts.place && (location.place_type || [])?.includes('address')) {
                        city = parts.place;
                    }
					let formatted = {
						full: location.place_name,
						city,
						country: parts.country,
						state: parts.region,
						longitude: location.center[0],
						latitude: location.center[1]
					};
					console.log({ location, event, formatted })

					this.props.setValue(formatted, true);
					// location object from mapbox
					// event onMouseDown supplied if suggestion clicked
				}}
				selectColor="#5F3DB1"
			/>
		);
	}

	render()
	{
        let className = this.props.showRequired() ? 'required ' : '';

        className += !this.props.isValid() && this.props.isFormSubmitted() ? 'text-danger' : '';
        let inputClassName = !this.props.isValid() && this.props.isFormSubmitted() ? 'is-invalid' : '';
        if (this.props.disabled) {
            inputClassName += ' disabled'
        }

		return (
	        <div className={"form-group " + className}>
				{this.props.label !== false && (
					<label className="col-form-label">
                        {this.props.label || 'Location'}
                        {this.props.required && <span className="required-symbol"> *</span>}
					</label>
				)}

	        	<div className={`form-component ${inputClassName} text-dark`} id="locationField">
		        	{this.renderPlaceSearch()}
    			</div>

    			<div className="invalid-feedback">
    				<div>{this.props.getErrorMessage()}</div>
    			</div>
	        </div>
		);
	}
}

export default withFormsy(LocationField);